import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';
import VulnerabilitiesTable from './VulnerabilitiesTable';
import { useTenantSelection } from '../../providers/TenantSelectionProvider';
import { useVulnerabilityService } from '../../components/services/vulnerabilityService';

type VulnerabilitySource = string;

const VulnerabilityCenter = () => {
  const [source, setSource] = useState<VulnerabilitySource>('Patchifi');
  const [sourceOptions, setSourceOptions] = useState<string[]>(['Patchifi']);
  const { selectedTenantId } = useTenantSelection();
  const { getSubscribedVulnerabilityProducts } = useVulnerabilityService();

  useEffect(() => {
    let isMounted = true;

    const loadSubscribedProducts = async () => {
      if (!selectedTenantId) {
        if (isMounted) {
          setSourceOptions(['Patchifi']);
        }
        return;
      }

      try {
        const response = await getSubscribedVulnerabilityProducts(selectedTenantId);
        const subscribedProducts = (response?.data || [])
          .map((product) => product?.name?.trim())
          .filter((name): name is string => Boolean(name));

        const nextSourceOptions = Array.from(new Set(['Patchifi', ...subscribedProducts]));

        if (isMounted) {
          setSourceOptions(nextSourceOptions);
          setSource((currentSource) => (nextSourceOptions.includes(currentSource) ? currentSource : 'Patchifi'));
        }
      } catch (error) {
        console.error('Error fetching subscribed vulnerability products:', error);

        if (isMounted) {
          setSourceOptions(['Patchifi']);
          setSource('Patchifi');
        }
      }
    };

    loadSubscribedProducts();

    return () => {
      isMounted = false;
    };
  }, [selectedTenantId]);

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className="flex-1" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
        <Header
          title="Vulnerability Center"
          dropdown={2}
          sourceOptions={sourceOptions}
          selectedSource={source}
          onSourceChange={(value) => setSource(value as VulnerabilitySource)}
        />

        <Card className="flex-1" bgColor="rgb(7, 7, 7)" border={true} borderColor="#474646" borderSide="left">
          <VulnerabilitiesTable source={source} />
        </Card>
      </div>
    </div>
  );
};

export default VulnerabilityCenter;
